export const msalConfig = {
    auth: {
      clientId: "73aaf223-c785-47cd-acce-ccb9acced062",
      authority: "https://login.microsoftonline.com/{e39fea5f-5767-4a9d-9642-dd6f119908c5}", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: process.env.REACT_APP_REDIRECT_URI,
      // redirectUri: "http://localhost:3000",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
    scopes: ["User.Read"]
  };
  
  export const apiConfig = {
   apiUri: process.env.REACT_APP_API_URI,

    // apiUri:"https://localhost:44380/api",
    scopes:["api://b412236f-579e-416a-ad10-fbb98330173f/.default"]
  }
